module.exports = __webpack_public_path__ + "img/sw-ys22.0fd742ff.jpg";